import './App.scss';
import Layout from 'Containers/Layout/Layout';

function App() {
    return (
        <>
            <Layout />
        </>
    );
}

export default App;
